export type Faces = { dice: [sides: number, value: number][]; modifier: number };

const TERMS = /([+-]?)(?:(\d*)d(\d+)|(\d+))/g;
const VALUES = /-? ?\d+/g;

const values = (result: string) => [...String(result ?? "").matchAll(VALUES)].map(([value]) => Number(value.replace(" ", "")));

// DiceRoll#total's twin.
export function rollTotal(result: string) {
	return values(result).reduce((sum, value) => sum + value, 0);
}

// Each die's value in the notation's order, and the flat numbers summed; null
// when the result does not pair with the notation. The twin of DiceRoll#faces,
// held to the same cases in test/fixtures/files/dice_faces_vectors.json.
export function faces(notation: string, result: string): Faces | null {
	const rest = values(result);
	const dice: Faces["dice"] = [];
	let modifier = 0;

	for (const [, sign, count, sides, number] of String(notation ?? "").matchAll(TERMS)) {
		const negative = sign === "-";
		if (sides) {
			for (let i = 0; i < Number(count || 1); i++) {
				const value = rest.shift();
				if (value === undefined || Math.abs(value) < 1 || Math.abs(value) > Number(sides) || value < 0 !== negative) return null;
				dice.push([Number(sides), value]);
			}
		} else {
			const value = rest.shift();
			if (value !== (negative ? -Number(number) : Number(number))) return null;
			modifier += value;
		}
	}

	return dice.length && !rest.length ? { dice, modifier } : null;
}
